import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { APP_SETTINGS } from '@services';
import { SubscriptionLike as ISubscription } from 'rxjs';
import { AuthService } from '../../../core/services/auth/auth.service';
import { UtilityService } from '../../../core/services/utility/utility.service';
import { VideosService } from '../../videos/videos.service';
import { NgIf, NgClass } from '@angular/common';
@Component({
    selector: 'app-noise-catalog-left-navigation-pane',
    templateUrl: './noise-catalog-left-navigation-pane.component.html',
    styleUrls: ['./noise-catalog-left-navigation-pane.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        NgIf,
        RouterLink,
        NgClass,
    ],
})
export class NoiseCatalogLeftNavigationPaneComponent implements OnInit, OnDestroy {

  public currentRoute = '';
  public currentChannel = '';
  private subscription: ISubscription[] = [];
  public hideTopNavbar = true;

  screenWidth: number;
  APP_SETTINGS : any;
  username: string;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private videoService: VideosService,
    private utilityService: UtilityService,
    private authService: AuthService,
    private changeDetector: ChangeDetectorRef
  ) {
    this.screenWidth = this.utilityService.getScreenWidth();
  }

  ngOnInit() {
    this.APP_SETTINGS = APP_SETTINGS;
    this.username = this.authService.getUserName();
    this.currentRoute = this.route.snapshot.children[0].url[0].path;
    this.currentChannel = this.route.snapshot.children[0].params['id'];
    // this.subscription.push(this.router.events.subscribe(event => {
    //   if (event instanceof NavigationEnd) {
    this.subscription.push(this.router.events.subscribe(event => {
      this.currentRoute = this.route.snapshot.children[0].url[0].path;
      this.changeDetector.detectChanges();
      this.currentChannel = this.route.snapshot.children[0].params['id'];
    }));

    if (this.currentRoute === 'channels' || this.currentRoute === 'channel-info' || this.currentRoute === 'manage-subscription') {
      this.hideTopNavbar = false;
    } else {
      this.hideTopNavbar = true;
    }
    // }
    if (this.route.snapshot.children[0].params.hasOwnProperty('id')) {
      this.currentRoute = this.route.snapshot.children[0].params['id'];
    }
    // }));

  }

  broadcastChannelNumber(channelNumber) {
    this.utilityService.publishChannelNumber(channelNumber);
  }
  ngOnDestroy(): void {
    this.subscription.forEach(subcribe => subcribe.unsubscribe());
  }
  screenRotate(event) {
    this.screenWidth = this.utilityService.getScreenWidth();
  }
}
